export const removedPayloadTypeDef = `
  id
`;
